import { useFormatPrice } from 'hooks/formatting/useFormatPrice';
import { PricePerUnit } from 'types/product';

type PricePerUnitWidgetProps = {
    pricePerUnit: PricePerUnit;
};

export const PricePerUnitWidget = ({ pricePerUnit }: PricePerUnitWidgetProps) => {
    const { formatPriceNumber: formatPrice } = useFormatPrice();

    const formattedPrice = formatPrice(pricePerUnit.price, { minimumFractionDigits: 2 });

    return <div className="text-small font-normal">{`${formattedPrice}/${pricePerUnit.unit}`}</div>;
};
